import { Icon } from '@octano/global-ui';
import { ReactElement } from 'react';

export function PerformanceAnalysisTableModalButton({
  onClick,
  names,
  many,
  zero = '-',
}: {
  onClick: () => void;
  names: (string | ReactElement)[];
  many: string;
  zero?: string;
}) {
  return (
    <div
      className="d-flex justify-content-center"
      style={{ position: 'relative' }}
    >
      {!names.length && zero}
      {names.length === 1 && names[0]}
      {names.length > 1 ? (
        <>
          {many}
          <span className="ml-1 cursor-pointer" onClick={onClick}>
            <Icon name="information" />
          </span>
        </>
      ) : null}
    </div>
  );
}
